import { BaseController } from '../../base/controller';
import _ from 'lodash';

export class CardController extends BaseController {
  constructor(controllerService, cardService, $scope) {
    'ngInject';
    super({ controllerService, cardService, $scope });

    this.showStatus = null;
    this.showStatusPromise = null;
  }

  get status() {
    return (
      this.showStatus ||
      (this.card.states &&
        _.map(this.card.states, (s) => this.getStatusTranslation(s)).join(', '))
    );
  }

  get hasFooter() {
    return !!(this.status || this.card.contractingPartners);
  }

  get hasSections() {
    return !!(this.card.sections && this.card.sections.length);
  }

  get renderSections() {
    return this.hasSections && angular.isDefined(this.isCardOpen);
  }

  get hasActions() {
    return !!(this.card.actions && this.card.actions.length);
  }

  get isRemoved() {
    return this.card.removable && this.card.removable.removed;
  }

  get isReadonly() {
    return this.card.readonly;
  }

  get isPreferredContactOnline() {
    return this.card.partner.preferredContact === 'online';
  }

  $onInit() {
    this.card.error = this.cardService.cardError(this.card);
  }

  getStatusTranslation(action, invert = false) {
    const active = invert ? !action.active : action.active;
    let appendix = active ? 'active' : 'deactive';
    return `app.card.status.${action.name}.${appendix}`;
  }

  openCard() {
    this.cardService.openCard(this.card).then(
      (card) => {},
      (card) => {},
    );
  }

  cancelContractClick() {
    this.cardService.cancelContractingPartner(this.card).then(
      (res) => {},
      (res) => {},
    );
  }

  toggleCheck($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.completeChecked = !this.completeChecked;
  }

  disablePaymentPartnerCancellation($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.card.cancelContractPartner.cancel = false;
  }

  get hasInformPartnerMethodAutomatic() {
    return this.card.informPartnerMethod === 'automatic';
  }

  toggleInformPartnerMethod($event, value = false) {
    $event.stopPropagation();
    $event.preventDefault();
    this.card.informPartnerMethod = value ? 'automatic' : 'manual';
    this.card.error = this.cardService.cardError(this.card);
  }

  clickCard($event) {
    if (this.isRemoved) {
      return this.toggleRemove($event);
    }
    this.openCard();
  }

  toggleRemove($event) {
    $event.stopPropagation();
    $event.preventDefault();
    //this.openCard(false);
    this.card.removable.removed = !this.card.removable.removed;
    this.card.removable.onRemove(this.card.removable.removed);
  }

  toggleStatusFor(action) {
    const { $timeout, showStatusPromise } = this;
    if (showStatusPromise) {
      $timeout.cancel(showStatusPromise);
    }

    this.showStatus = this.getStatusTranslation(action, true);
    $timeout(() => {
      this.showStatus = null;
    }, 2000);
  }

  errorClick() {
    this.openCard();
  }

  stopEvent($event) {
    //$event.stopPropagation();
    //$event.preventDefault();
  }

  blur() {
    // NOTE: It would be awesome if we could close a card on blur
    // but sadly we actual cannot do this because the blur $event
    // is being triggered even if we click inside the card.
    // This is caused by the absolute positioned menu of an opened card
    // which is not a child but and sibling element of the card :/
    this.hasFocus = false;
    // this.openCard(false);
  }

  focus() {
    this.hasFocus = true;
  }
}
